import React from 'react'
import { connect } from 'react-redux'
import { Field, formValueSelector } from 'redux-form'
import { Input, Select } from '../../../../../../../../../itrust_common/components/form'
import VersantLabLensFields from './VersantLabLensFields'
import VersantFrameInformationFields from './VersantFrameInformationFields'

const selector = formValueSelector('VersantClaimForm')
const req = (label) => <>{label} <span className="text-danger">*</span></>
const onlyNumber = (value) => (value == null || value === '' ? value : String(value).replace(/[^\d.-]/g, ''))
const PRISM_IN_OUT = [{ name: 'In', value: 'In' }, { name: 'Out', value: 'Out' }]
const PRISM_UP_DOWN = [{ name: 'Up', value: 'Up' }, { name: 'Down', value: 'Down' }]
const RX = 'spectacle_lens.perscriptions'
const filled = (value) => value !== undefined && value !== null && String(value).trim() !== ''

const RxRow = ({ side, label, showLabels, prescriptions = {} }) => {
  const cylinder = prescriptions[`${side}_cyclinder`]
  const axis = prescriptions[`${side}_axis`]
  const addition = prescriptions[`${side}_addition`]
  const showRequired = filled(cylinder) || filled(axis) || filled(addition)

  return (
    <div className="row align-items-end mb-3">
      <div className="col-2"><label className="font-weight-bold mb-0">{label}</label></div>
      <Field name={`${RX}.${side}_sphere`} component={Input} label={showLabels ? req('Sphere') : undefined} className="form-control" wrapperClasses="col form-group mb-0" normalize={onlyNumber} />
      <Field name={`${RX}.${side}_cyclinder`} component={Input} label={showLabels ? (showRequired ? req('Cylinder') : 'Cylinder') : undefined} className="form-control" wrapperClasses="col form-group mb-0" normalize={onlyNumber} />
      <Field name={`${RX}.${side}_axis`} component={Input} label={showLabels ? (showRequired ? req('Axis') : 'Axis') : undefined} disabled={!filled(cylinder)} className="form-control" wrapperClasses="col form-group mb-0" normalize={onlyNumber} />
      <Field name={`${RX}.${side}_addition`} component={Input} label={showLabels ? (showRequired ? req('Addition') : 'Addition') : undefined} disabled={!filled(cylinder) || !filled(axis)} className="form-control" wrapperClasses="col form-group mb-0" normalize={onlyNumber} />
    </div>
  )
}

const PrismRow = ({ side, label, showLabels }) => (
  <div className="row align-items-end mb-3">
    <div className="col-2"><label className="font-weight-bold mb-0">{label}</label></div>
    <Field name={`${RX}.${side}_prism_base_1`} component={Select} label={showLabels ? 'Prism In/Out' : undefined} data={PRISM_IN_OUT} textField="name" valueField="value" placeholder="Select One" wrapperClasses="col-3 form-group mb-0" />
    <Field name={`${RX}.${side}_prism_value_1`} component={Input} className="form-control" wrapperClasses="col-2 form-group mb-0" normalize={onlyNumber} />
    <Field name={`${RX}.${side}_prism_base_2`} component={Select} label={showLabels ? 'Prism Up/Down' : undefined} data={PRISM_UP_DOWN} textField="name" valueField="value" placeholder="Select One" wrapperClasses="col-3 form-group mb-0" />
    <Field name={`${RX}.${side}_prism_value_2`} component={Input} className="form-control" wrapperClasses="col-2 form-group mb-0" normalize={onlyNumber} />
  </div>
)

const PdGroup = ({ label, required, rightName, leftName }) => (
  <div className="col">
    <label>{required ? req(label) : label}</label>
    <div className="d-flex">
      <Field name={rightName} component={Input} className="form-control mr-3" wrapperClasses="form-group mb-0" normalize={onlyNumber} />
      <Field name={leftName} component={Input} className="form-control" wrapperClasses="form-group mb-0" normalize={onlyNumber} />
    </div>
    <div className="d-flex text-muted small mt-1">
      <span className="flex-fill">(RE) mm</span>
      <span className="flex-fill">(LE) mm</span>
    </div>
  </div>
)

function VersantSpectacleLensFields({ prescriptions }) {
  return (
    <>
      <div className="border rounded p-5 mb-6">
        <h6 className="mb-5">Prescription Information</h6>
        <div className="row">
          <div className="col-6">
            <RxRow side="right" label="Right" showLabels prescriptions={prescriptions} />
            <RxRow side="left" label="Left" prescriptions={prescriptions} />
          </div>
          <div className="col-6">
            <PrismRow side="right" label="Right" showLabels />
            <PrismRow side="left" label="Left" />
          </div>
        </div>
        <div className="row mt-5">
          <div className="col-6">
            <div className="row">
              <PdGroup label="Distance PD" required rightName={`${RX}.right_distance_pd`} leftName={`${RX}.left_distance_pd`} />
              <PdGroup label="Near PD" rightName={`${RX}.right_near_pd`} leftName={`${RX}.left_near_pd`} />
              <PdGroup label="Height" rightName={`${RX}.right_height_pd`} leftName={`${RX}.left_heighte_pd`} />
            </div>
            <p className="text-muted small mt-3 mb-0">Note: PDs must be entered in monocular form.</p>
          </div>
        </div>
      </div>
      <VersantLabLensFields />
      <VersantFrameInformationFields />
    </>
  )
}

export default connect((state) => ({
  prescriptions: selector(state, 'spectacle_lens.perscriptions') || {},
}))(VersantSpectacleLensFields)
